export const routeName = 'round-up';
export const slugs: Record<string, string> = {
	en: 'round-up',
	es: 'redondeo-solidario',
	ca: 'arrodoniment-solidari',
	it: 'arrotondamento-solidale',
};
export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2025-01-01' };
